module.exports = __webpack_public_path__ + "static/media/EmmaChurch.021fe8f1.jpg";